import { observable, computed, action, makeObservable } from 'mobx'
import ChangeLogCollection from '../Collections/ChangeLogCollection'
import PhaseCollection from '../Collections/PhaseCollection'
import ProjectCollection from '../Collections/ProjectCollection'
import Model from './Model'

class ChangeLogModel extends Model {
    @observable date = null
    @observable title = null
    @observable revenueType = null
    @observable revenue = null
    @observable expenses = null
    @observable percentProgress = null
    @observable projectId = null
    @observable phaseId = null

    constructor(data, options) {
        super()
        makeObservable(this)
        this.collection = ChangeLogCollection
        this.init(data, options)
    }

    @computed
    get phase() {
        return PhaseCollection.phasesById[this.phaseId]
    }

    @computed
    get project() {
        return ProjectCollection.projectsById[this.projectId]
    }
}

export default ChangeLogModel
